import { useMemo } from "react";
import { useRecoilValue } from "recoil";

import { useConfig } from "src/hooks/config";
import Money from "src/common/components/money";
import { getBetCalculations } from "calculation";
import upperDataStore from "src/stores/upperData";
import { useTranslation } from "src/hooks/translation";
import { BetCalculationsEnum } from "src/constants/enums/betCalculations";
import selectionsStore from "src/stores/selections";
import mainStore from "src/stores/main";
import { BetTypeEnum } from "src/constants/enums/betType";

interface IProps {
  stake: number;
}

const BetDetailsTotalStake = ({ stake }: IProps) => {
  const t = useTranslation();
  const config = useConfig();
  const { selections } = useRecoilValue(selectionsStore);
  const { partnerConfig, currencyConfig } = useRecoilValue(upperDataStore);
  const { betType } = useRecoilValue(mainStore);

  const finalStake = betType === BetTypeEnum.Single && config.enableSingleStakeInput
    ? selections.map(item => +(item.singleStake || '')).filter(Boolean).reduce((acc, item) => acc + item, 0)
    : stake;

  const { taxedStake } = useMemo(
    () =>
      getBetCalculations([BetCalculationsEnum.TaxOnStake], {
        config,
        partnerConfig,
        stake: +finalStake,
        currencyConfig,
      }),
    [config, finalStake, currencyConfig, partnerConfig]
  );

  if (!taxedStake) return null;

  return (
    <div className="B-betslip-bet-details-info-row">
      <p className="B-info-row-title">{t("Total stake:")}</p>
      <p className="B-info-row-number">
        <Money amount={taxedStake} />
      </p>
    </div>
  );
};

export default BetDetailsTotalStake;
